/**
 * Devuelve sólo el path de un `asPath`: ni query-string ni hash.
 *
 * Usar SIEMPRE que `router.asPath` entre como variable de una query de Apollo, porque en ese
 * caso forma parte de la llave de caché y **no es idéntico en servidor y cliente**:
 *
 * - el servidor lo re-serializa desde la query ya parseada (`?utm_source` -> `?utm_source=`,
 *   y se come un `&` final);
 * - el navegador nunca manda el hash, así que el servidor no lo ve y el cliente sí.
 *
 * Con la URL completa la llave del caché SSR no matchea la del cliente, éste re-pide, y el
 * primer render del cliente queda en `loading`. Si el componente devuelve `null` mientras
 * carga, el nodo desaparece de la lista de hermanos y React 16 hidrata mal (INF-263: el SERP
 * se tragaba una propiedad dentro de una AI citation).
 *
 * Antes de usarlo hay que verificar que el backend no dependa del query-string para esa query
 * (mandar varias `url` con el resto de las variables igual y comparar respuestas).
 * Verificado para `seoMetaTags`, `getTrendingRecommendations` (INF-269) y las AI citations
 * (INF-263).
 */
export const canonicalAsPath = (asPath: string): string => asPath.split(/[?#]/)[0];
